import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// A compact live/pending status pill for the premium satellite streams (Landsat/ASTER/EnMAP).
// Green + pulsing when any premium stream is live; muted "pending" until keys are added.
export function SatelliteStreamChip({ testid = "eo-stream-chip", className = "" }) {
  const [streams, setStreams] = useState(null);
  useEffect(() => {
    let alive = true;
    api.get("/sensors").then((r) => alive && setStreams(r.data)).catch(() => {});
    return () => { alive = false; };
  }, []);

  if (!streams) return null;
  const active = (streams.sources || []).filter((s) => ["landsat", "aster", "enmap"].includes(s.id) && s.live);

  if (active.length > 0) {
    return (
      <span data-testid={testid} title={`Premium satellite streams live: ${active.map((s) => s.label).join(", ")}`}
        className={`hidden md:inline-flex items-center gap-1.5 rounded-full px-2.5 h-6 text-[11px] font-semibold border border-emerald-500/40 bg-emerald-500/10 text-emerald-400 shrink-0 ${className}`}>
        <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 animate-pulse" />
        {active.map((s) => (s.label || "").split(/[\s(]/)[0]).join(" · ")} active
      </span>
    );
  }
  return (
    <span data-testid={testid}
      title="Sentinel-2 is live. Add NASA (ASTER) & AWS (Landsat) keys in Admin → Satellite Providers to activate premium streams."
      className={`hidden md:inline-flex items-center gap-1.5 rounded-full px-2.5 h-6 text-[11px] font-medium border border-border bg-muted text-muted-foreground shrink-0 ${className}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-muted-foreground/50" />
      Premium streams pending
    </span>
  );
}
